module.exports = __webpack_public_path__ + "media/images/front/icon_instagram-20ae7bc178234efe5a0fcddf611e492b.png";